import React from 'react';

import { Translator } from 'ggApp/modules/translator';

import { Wrap, Text } from './styled';

const TrialCard = ({ className, price }: { className?: string; price: string }): JSX.Element => (
    <Wrap className={className}>
        <Text>
            <Translator tk="PDP_TRIAL_CARD_TEXT" withValues={{ price }} />
        </Text>
    </Wrap>
);

export default TrialCard;
